<template>
  <div class="container step">
    <div class="group-container">
      <div class="group" v-for="(row,key) in dataRow" :key="key">
        <div class="content">
            {{row.title}}
        </div><!-- content end sub -->
        <div :class="'checkboxGroup' + ( row.half ? ' half' : '')">
          <div :class="'item' + (rows.text == '人' ? ' text-inline' : '')" v-for="rows in row.checkbox" :key="rows.id">
            <input type="radio" @change="onChangeData(rows, row.keys)" :name="'s'+row.keys" :id="rows.id">
            <label :for="rows.id" class="text">
              <input type="text" v-model="rows.remark" @keypress="onChangeData(rows, row.keys)" v-if="rows.text == '人'">
              <span class="checkboxText">{{rows.text}}</span>
              <textarea
              v-model="rows.remark"
              v-if="rows.text == '其他'" name="" placeholder="輸入文字"
              class="textarea" rows="4">
            </textarea>
            </label>
          </div>
        </div><!-- checkbox group end sub -->
      </div><!-- group end sub -->
    </div>
    <template>
      <router-link to="/step2" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step2-2" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'step1-1',
  data () {
    return {
      pageChage: false,
      props: ['result'],
      selectData: {
        'step2-1': {
          id: '',
          text: '',
          remark: ''
        },
        'step2-2': {
          id: '',
          text: '',
          remark: ''
        }
      },
      dataRow: [
        {
          keys: 'step2-1',
          title: '目前在臨床上上泌尿道上皮癌(UTUC)患者很常見,請問,您目前平均每月治療的”局部晚期或轉移性”泌尿道上皮癌病人約有多少人？',
          half: false,
          checkbox: [
            {
              id: 's1-1',
              text: '人',
              remark: ''
            }
          ]
        },
        {
          keys: 'step2-2',
          title: '在臨床上,遇到化療副作用耐受力較差的轉移性上泌尿道上皮癌患者,您會採用何種治療選擇?可複選',
          half: false,
          checkbox: [
            {
              id: 's2-1',
              text: '改用carboplatin類化療',
              remark: ''
            },
            {
              id: 's2-2',
              text: '改用免疫療法(cancer immunotherapy)',
              remark: ''
            },
            {
              id: 's2-3',
              text: '其他',
              remark: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    onChangeData: function ($row, keys) {
      var val = this.selectData
      val[keys] = $row
      if ((val['step2-1']['id'] !== '') && (val['step2-2']['id'] !== '')) {
        // if ($.isNumeric(val['step2-1']['remark']) === false) {
        //   return
        // }
        this.$emit('update:result', val)
        this.pageChage = true
      }
    }
  }
}
</script>

<style scoped>
  .container {text-align:center;}
  .container:before,
  .container:after {
    content:"";display:inline-block;
    vertical-align:middle;
    height:100%;width:0px;
  }
  .step .group .content {
    background:#f5ad33;
  }
  .step .checkboxGroup .item input[type='radio']:checked + .text:before {
    background:#f5ad33;border-color:#f5ad33;
  }
  a[class*="btn-"] {
    background:#f39800;color:white;
  }
</style>



// WEBPACK FOOTER //
// src/components/step2/question.vue